import React from 'react';
import { Box, Paper, Skeleton } from '@/shared/ui';

const ROW_COUNT = 8;
const COL_COUNT = 5;

const ListPageSkeleton: React.FC = () => (
  <Paper
    variant="outlined"
    elevation={0}
    sx={{
      flex: 1,
      minHeight: 0,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    }}
  >
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: `repeat(${COL_COUNT}, 1fr)`,
        gap: 2,
        px: 2,
        py: 1.5,
        borderBottom: 1,
        borderColor: 'divider',
        bgcolor: 'action.hover',
      }}
    >
      {Array.from({ length: COL_COUNT }, (_, i) => (
        <Skeleton key={`h-${i}`} variant="text" width={`${55 + (i % 3) * 10}%`} height={24} />
      ))}
    </Box>

    <Box sx={{ flex: 1, overflow: 'hidden' }}>
      {Array.from({ length: ROW_COUNT }, (_, row) => (
        <Box
          key={`r-${row}`}
          sx={{
            display: 'grid',
            gridTemplateColumns: `repeat(${COL_COUNT}, 1fr)`,
            gap: 2,
            px: 2,
            py: 1.75,
            borderBottom: 1,
            borderColor: 'divider',
            alignItems: 'center',
          }}
        >
          {Array.from({ length: COL_COUNT }, (_, col) => (
            <Skeleton
              key={`c-${row}-${col}`}
              variant="rounded"
              height={col === 0 ? 20 : 16}
              width={`${50 + ((row + col) % 4) * 12}%`}
            />
          ))}
        </Box>
      ))}
    </Box>
  </Paper>
);

export default ListPageSkeleton;
